import React from 'react'
import { useNavigate } from 'react-router-dom'
import './SubscriptionBlock.css'
import logo from '../../assets/images/logo.svg'

interface SubscriptionBlockProps {
  hasSubscription?: boolean
  buttonText?: string
}

const SubscriptionBlock: React.FC<SubscriptionBlockProps> = ({
  hasSubscription = false,
  buttonText = 'Хочу в чат',
}) => {
  // Показываем блок только для пользователей без подписки
  if (hasSubscription) {
    return null
  }

  const navigate = useNavigate()
  const handleJoinChat = () => {
    navigate('/subscribe')
  }

  return (
    <div className="subscription-block">
      <div className="subscription-block-text-container">
        <div className="subscription-block-subtitle">
          Больше возможностей с подпиской
        </div>
        <img src={logo} alt="Logo" className="subscription-block-logo" />
        <div className="subscription-block-description">
          Открой доступ ко всем 250+ рецептам и урокам
        </div>
      </div>
      <button className="subscribe-button" onClick={handleJoinChat}>
        {buttonText}
      </button>
    </div>
  )
}

export default SubscriptionBlock
